import { Link } from "react-router-dom";
import type { X402LinkedAccount } from "../../lib/x402Discovery";

export function preferredReviewerAccount(accounts: X402LinkedAccount[]): X402LinkedAccount | undefined {
  return accounts.find((account) => account.verification === "boon_oauth_link") ?? accounts[0];
}

export function X402ReviewerIdentities({
  accounts,
  resolution,
}: {
  accounts: X402LinkedAccount[];
  resolution: "complete" | "unavailable";
}) {
  const ordered = [...accounts].sort((left, right) => {
    const leftRank = left.verification === "boon_oauth_link" ? 0 : 1;
    const rightRank = right.verification === "boon_oauth_link" ? 0 : 1;
    return leftRank - rightRank || left.handle.localeCompare(right.handle);
  });

  return (
    <section className="mt-6 max-w-3xl" aria-label="Wallet identities">
      <p className="btn-mono text-[10px] uppercase tracking-[0.16em] text-muted">Linked identities</p>
      {ordered.length > 0 ? (
        <div className="mt-3 grid gap-px overflow-hidden rounded-md border border-faint bg-faint sm:grid-cols-2">
          {ordered.map((account) => (
            <div key={account.handle} className="bg-paper p-4">
              <div className="flex flex-wrap items-center gap-2">
                <Link
                  className="font-semibold text-olive-deep hover:underline"
                  to={`/p/${encodeURIComponent(account.handle)}`}
                >
                  {account.handle}
                </Link>
                <span className="pill pill-faint text-[10px]">
                  {account.verification === "boon_oauth_link" ? "OAuth-linked" : "ERC-8004 indexed"}
                </span>
              </div>
              <a
                className="mt-2 inline-flex min-h-8 items-center btn-mono text-xs text-muted hover:text-olive-deep hover:underline"
                href={account.profileUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {externalProfileLabel(account)} ↗
              </a>
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-3 text-sm text-muted">
          {resolution === "unavailable"
            ? "Linked identity lookup is temporarily unavailable. Reviews remain wallet-authenticated."
            : "No GitHub, X, or ERC-8004 identity is linked to this wallet."}
        </p>
      )}
      {ordered.length > 0 && resolution === "unavailable" && (
        <p className="mt-2 text-xs text-muted">Some linked identities may be missing because identity lookup is temporarily unavailable.</p>
      )}
    </section>
  );
}

function externalProfileLabel(account: X402LinkedAccount): string {
  if (account.provider === "github") return "Open GitHub profile";
  if (account.provider === "x") return "Open X profile";
  return "Open ERC-8004 profile";
}
